import { Injectable } from '@angular/core'
import { Subject } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class InfoPopupService {
  showInfoPopup = new Subject<string>()

  constructor() {}

  notify(text?: string) {
    this.showInfoPopup.next(text)
  }
}
